import { CheckCircleIcon, Code2 } from 'lucide-react';
import React from 'react';

interface ActiveProfileInfoCardProps {
  name: string;
  code: string;
  description?: string;
}

const ActiveProfileInfoCard: React.FC<ActiveProfileInfoCardProps> = ({
  name,
  code,
  description,
}) => {
  return (
    <div className="relative w-full rounded-xl border border-stroke bg-white p-5 shadow-sm transition-all duration-200 dark:border-strokedark dark:bg-boxdark-2">
      {/* Encabezado */}
      <div className="mb-3 flex items-center">
        <CheckCircleIcon
          className="mr-2 h-5 w-5 text-emerald-500"
          strokeWidth={2}
        />
        <h3 className="text-gray-800 dark:text-gray-100 text-base font-semibold">
          Perfil activo
        </h3>
      </div>

      {/* Nombre del perfil */}
      <p className="text-gray-800 dark:text-gray-100 mb-1 text-lg font-medium">
        {name}
      </p>

      {/* Código */}
      <p className="text-gray-600 dark:text-gray-400 mb-2 flex items-center gap-2 text-sm">
        <Code2
          className="h-4 w-4 text-emerald-600 dark:text-emerald-400"
          strokeWidth={2}
        />
        <span className="font-mono rounded-md bg-emerald-100 px-2 py-0.5 text-xs text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300">
          {code}
        </span>
      </p>

      {/* Descripción opcional */}
      {description && (
        <p className="text-gray-500 dark:text-gray-400 border-gray-200 dark:border-gray-700 mt-2 border-t pt-2 text-xs italic">
          {description}
        </p>
      )}
    </div>
  );
};

export default ActiveProfileInfoCard;
